var map = {
	"./discharge.svg": 356,
	"./female.svg": 409,
	"./intra.svg": 357,
	"./left.svg": 1316,
	"./loading_icon.svg": 1317,
	"./male.svg": 408,
	"./post.svg": 358,
	"./pre.svg": 359,
	"./right.svg": 1318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1315;